// discoveryStateSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type GenerateFormSuccessResponse } from './ApplicationCard';

export interface DiscoveryTestConnectionState {
  loading: boolean;
  error: string | null;
  data: GenerateFormSuccessResponse | null;
}

const initialState: DiscoveryTestConnectionState = {
  loading: false,
  error: null,
  data: null,
};

const generateTemplateSlice = createSlice({
  name: 'generateTemplate',
  initialState,
  reducers: {
    setGenerateTemplateLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setGenerateTemplateError: (
      state,
      action: PayloadAction<string | null>
    ) => ({
      ...state,
      error: action.payload,
    }),
    resetGenerateTemplateState: () => initialState,
  },
});

export const {
  setGenerateTemplateError,
  setGenerateTemplateLoading,
  resetGenerateTemplateState,
} = generateTemplateSlice.actions;
export default generateTemplateSlice;
